import styled from 'styled-components';

export const MainWrapper = styled.div`
  flex-grow: 1;
  background-color: #f5f4f7;
`;
